import { render } from "./About.vue?vue&type=template&id=d881dcee&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=d881dcee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d881dcee"

export default script